import { Box, Center, Text } from "@mantine/core"
import { DatabaseIcon } from "@phosphor-icons/react";
import { ReactNode } from "react"
import { useTranslation } from "react-i18next"

type Props = {
  /** Override icon (defaults to DatabaseIcon) */
  icon?: ReactNode
  /** Custom message; falls back to common:table.noData translation */
  message?: ReactNode
  /** Optional action node rendered below the message (e.g. a Button) */
  action?: ReactNode
  /** Reduce vertical padding for inline empty states */
  compact?: boolean
}

/**
 * Centered no-data placeholder. Used inside table empty rows and list
 * pages when no records match the current filters. Pair with
 * <Center> already wrapping it (the component centers internally).
 */
export function EmptyState({ icon, message, action, compact = false }: Props) {
  const { t } = useTranslation("common")
  return (
    <Center style={{ flexDirection: "column", gap: 10, padding: compact ? 16 : 32 }}>
      {icon ?? <DatabaseIcon size={36} color="var(--mantine-color-gray-5)" />}
      <Text fz={14} c="var(--mantine-color-gray-6)" ta="center">
        {message ?? t("table.noData")}
      </Text>
      {action && <Box>{action}</Box>}
    </Center>
  )
}
